export const dealerMonthlyFeeFilterState = () => ({
  month: null,
  year: null,
  perPage: 10,
  page: 1,
});
